import API from '../../services/API'

export async function getPendingRelationshipSuggestionList(ctx: any) {
    try {
        ctx.commit('SET_LOADING', { pendingSuggestionList: true })
        const { data, meta } = await API.getMyPendingSuggestions()
        ctx.commit('SET_RELATIONSHIP_SUGGESTION_LIST', {
            pendingRelationshipSuggestionList: data,
            pendingRelationshipSuggestionListPager: meta.pager,
        })
    } catch (e) {
        Promise.reject(e)
        ctx.commit('SET_RELATIONSHIP_SUGGESTION_LIST', {
            pendingRelationshipSuggestionList: [],
            pendingRelationshipSuggestionListPager: null,
        })
    } finally {
        ctx.commit('SET_LOADING', { pendingSuggestionList: false })
    }
}

export async function searchMembers(ctx: any, { page }: any = {}) {
    try {
        ctx.commit('SET_LOADING', { searchedMemberList: true })
        const searchMemberResult = await API.searchMembers(
            ctx.state.searchFiltersSelected,
            page,
            ctx.state.sortMemberListBy
        )
        ctx.commit('SET_SEARCHED_MEMBER_LIST', { searchMemberResult })
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { searchedMemberList: false })
    }
}

export async function searchFilters(ctx: any) {
    try {
        ctx.commit('SET_LOADING', { searchFilters: true })
        const searchFilters = await API.searchMembersFilters(ctx.state.searchFiltersSelected)
        ctx.commit('SET_SEARCH_FILTERS', { searchFilters })
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { searchFilters: false })
    }
}


export async function getContactMemberList(ctx: any, { page }: any = {}) {
    try {
        ctx.commit('SET_LOADING', { contactMemberList: true })
        const contactMemberList = await API.getMyContactMemberList(
            ctx.state.searchFiltersSelected,
            page,
            ctx.state.sortMemberListBy
        )
        ctx.commit('SET_CONTACT_MEMBER_LIST', { contactMemberList })
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { contactMemberList: false })
    }
}

export async function getFavoriteMemberList(ctx: any) {
    try {
        ctx.commit('SET_LOADING', { favoriteMemberList: true })

        const favoriteMemberList = await API.getMyFavoriteMemberList(
            ctx.state.searchFiltersSelected,
            ctx.state.sortMemberListBy
        )
        ctx.commit('SET_FAVORITE_MEMBER_LIST', { favoriteMemberList })
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { favoriteMemberList: false })
    }
}

export async function getMemberListWithSameEvents(ctx: any) {
    try {
        ctx.commit('SET_LOADING', { sameEventsMemberList: true })
        const sameEventsMemberList = await API.getMembersWithSameEvent()
        ctx.commit('SET_SAME_EVENTS_MEMBER_LIST', { sameEventsMemberList })
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { sameEventsMemberList: false })
    }
}

export async function getNationalityList(ctx: any) {
    try {
        const nationalityList = await API.getNationalitiesAvailable()
        ctx.commit('SET_NATIONALITY_LIST', { nationalityList })

        return nationalityList
    } catch (e) {
        Promise.reject(e)
    }
}

export async function putLanguages(ctx: any, { spokenLanguages }: any) {
    const nationalities = ctx.state.me.nationalities
    const showNationalityOnProfile = ctx.state.me.show_nationality_on_profile

    try {
        return await API.editNationalities(ctx.state.member.id, {
            nationalities,
            spokenLanguages,
            showNationalityOnProfile,
        })
    } catch (e) {
        Promise.reject(e)
    }
}
